import dayjs from 'dayjs';

const locales = {
  // eslint-disable-next-line
  'en': () => import('dayjs/locale/en'),
  'es-mx': () => import('dayjs/locale/es-mx'),
  'pt-br': () => import('dayjs/locale/pt-br'),
};

export default {
  props: {
    locale: {
      type: String,
      default: 'en',
      validator(value) {
        return ['en', 'pt-br', 'es-mx'].includes(value);
      },
    },
  },
  watch: {
    locale: {
      async handler(value) {
        await locales[value]();
        dayjs.locale(value);
      },
      immediate: true,
    },
  },
};
